import React from "react";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function DetailsMismatch({
  classes: { formGroup },
  form,
  onClickHandler,
  onClose,
  modal,
  modalKey = "mismatch",
}) {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.mismatch}
      maxWidth={"md"}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"Verification Response"} />
      </DialogTitle>
      <Box m={1}>
        {form.name_in_bank ? (
          <>
            <Box className={formGroup}>
              <FieldLabel
                label={
                  "Mismatch in the name between Aadhaar and your bank account."
                }
              />
            </Box>

            <Box className={formGroup}>
              <FieldLabel
                label={`Name as per Aadhaar: ${form.bank_account_holder_name}`}
              />
            </Box>

            <Box className={formGroup}>
              <FieldLabel label={`Name as per Bank: ${form.name_in_bank}`} />
            </Box>
          </>
        ) : (
          <Box className={formGroup}>
            <FieldLabel
              label={"Error in Account Verification. Please try again"}
            />
          </Box>
        )}

        <Box mt={3}>
          <Button
            type={"button"}
            variant={"contained"}
            color={"primary"}
            size={"small"}
            onClick={onClickHandler}
            fullWidth
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(DetailsMismatch);
